import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=2d35781e&scoped=true"
import script from "./SearchCustomer.vue?vue&type=script&lang=js"
export * from "./SearchCustomer.vue?vue&type=script&lang=js"
import style0 from "./SearchCustomer.vue?vue&type=style&index=0&id=2d35781e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d35781e",
  null
  
)

export default component.exports